import { render, staticRenderFns } from "./monitorProductSettings.vue?vue&type=template&id=8714dd98&scoped=true&"
import script from "./monitorProductSettings.vue?vue&type=script&lang=js&"
export * from "./monitorProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./monitorProductSettings.vue?vue&type=style&index=0&id=8714dd98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8714dd98",
  null
  
)

export default component.exports